import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import svgChevronDown from '@img/icons/chevron-down.svg';
import svgTickGreen from '@img/icons/tick-green.svg';
import styled from 'styled-components';
const DropdownContainer = styled.div `
  display: flex;
  align-items: center;
  appearance: none;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 9px;
  color: ${cssVar('fgColor')};
  height: 48px;
  width: 100%;
  position: relative;
  cursor: pointer;

  &[aria-current='true'] {
    border-radius: 9px 9px 0 0;

    &::after {
      transform: rotate(180deg);
    }
  }

  @media ${from(Device.Desktop)} {
    background-position: center right 18px;
  }

  &::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    height: 48px;
    width: 42px;
    background: transparent url('${svgChevronDown}') no-repeat;
    background-position: center;
    background-size: 16px 8px;
    transition: transform 0.33s ease;
  }
`;
const ActiveDropdown = styled.div `
  ${fonts.sourceSansPro.regular};
  padding: 0 30px 0 12px;
  font-size: 16px;
  line-height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
    padding: 0 42px 0 24px;
  }

  strong {
    ${fonts.sourceSansPro.semiBold};
  }
`;
const Dropdown = styled.div `
  display: none;
  position: absolute;
  top: 100%;
  left: -1px;
  width: calc(100% + 2px);
  z-index: 2;
  max-height: 300px;
  overflow-y: auto;
  background-color: ${brand.white};
  border: 1px solid ${brand.greyLight};

  &[aria-current='true'] {
    display: block;
  }
`;
const DropdownItem = styled.div `
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${brand.greyLight};
  padding: 12px;
  ${fonts.sourceSansPro.regular};
  font-size: 16px;
  line-height: 20px;
  position: relative;
  min-height: 48px;
  transition: background-color 0.3s ease-in-out;

  @media ${from(Device.Desktop)} {
    font-size: 20px;
    line-height: 24px;
    padding: 12px 24px;
  }

  &[aria-multi='true'] {
    padding-left: 48px;

    &:before {
      content: '';
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      border: 1px solid ${brand.black};
      width: 24px;
      height: 24px;
    }
  }

  &[aria-current='true'][aria-multi='true'] {
    background-color: ${brand.white};

    &:before {
      background: transparent url('${svgTickGreen}') no-repeat;
      background-position: center center;
      background-size: 17px 12px;
    }
  }

  &:hover,
  &[aria-current='true'],
  &[aria-current='true'][aria-multi='true']:hover {
    background-color: ${brand.apl.greenLight};
  }
`;
export const CheckboxSelectStyles = {
    DropdownContainer,
    ActiveDropdown,
    Dropdown,
    DropdownItem,
};
